import {AbstractModel} from "../abstract-model";
import {User} from '../user';
import {Partner} from '../partner/partner';
import {ActivityComment} from './activity-comment';

export class Activity extends AbstractModel {
  id: number | null = null;
  type!: string;
  status: string = 'forthcoming';
  sender: User | null = null;
  recipient: User | null = null;
  partner: Partner | null = null;
  subject!: string;
  message!: string;
  pinned: boolean = false;
  messageRead: boolean = false;
  feedDisplay: boolean = true;
  repeatFrequency: string | null = null;
  alertTime: string | null = null;
  data: any | null = null;
  occurringDate: string | null = null;
  occurringTime: string | null = null;
  occurringAt: Date | null = null;
  updatedAt!: Date;
  createdAt!: Date;

  comments: ActivityComment[] = [];

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.sender) {
      this.sender = new User().deserialize(input.sender);
    }

    if (input.recipient) {
      this.recipient = new User().deserialize(input.recipient);
    }

    if (input.partner) {
      this.partner = new Partner().deserialize(input.partner);
    }

    if (input.comments) {
      this.comments = input.comments.map((comment: any) => new ActivityComment().deserialize(comment));
    }

    if (this.occurringAt) {
      this.occurringDate = this.formatDate(this.occurringAt);
      this.occurringTime = this.formatTime(this.occurringAt);
    }

    return this;
  }

  hasAction(): boolean {
    return !!this.data?.action;
  }

  isTask(): boolean {
    return this.type === 'task';
  }

  hasSender(): boolean {
    return !!this.sender;
  }

  isGlobal(): boolean {
    return this.hasSender() && !this.partner;
  }

  getOccurringAt(): string | null {
    if (!this.occurringDate || !this.occurringTime) {
      return null;
    }

    return this.occurringDate + ' ' + this.occurringTime;
  }

  formatDate(date: Date): string {
    return [
      date.getUTCFullYear(),
      String(date.getUTCMonth() + 1).padStart(2, '0'),
      String(date.getUTCDate()).padStart(2, '0')
    ].join('-');
  }

  formatTime(date: Date): string {
    return [
      String(date.getUTCHours()).padStart(2, '0'),
      String(date.getUTCMinutes()).padStart(2, '0'),
      '00'
    ].join(':');
  }

  getIconType(): string {
    switch (this.type) {
      case 'note':
        return 'bi-sticky-fill';
      case 'task':
        return 'bi-card-checklist';
      case 'account_manager_update':
        return 'bi-people-fill';
      case 'payment_terms_update':
        return 'bi-credit-card';
      case 'new_partner':
        return 'bi-person-plus-fill';
      case 'prospect_conversion':
        return 'bi-person-check-fill';
      case 'partner_offer_request':
        return 'bi-question-octagon-fill';
      case 'partner_account_update':
        return 'bi-person-lines-fill';
      case 'partner_activated':
        return 'bi-person-check-fill';
      case 'partner_rejected':
        return 'bi-person-fill-x';
      case 'signup':
        return 'bi-person-plus-fill';
    }

    return '';
  }

  getSubjectIcon(): string {
    switch (this.type) {
      case 'note':
        return 'bi-pencil-square';
      case 'task':
        return 'bi-card-text';
    }

    return '';
  }
}
